import app from 'flarum/forum/app';
import UploadedPost from './components/UploadedPost';

export default function () {
    app.postComponents.cimaiseUploaded = UploadedPost;
}
